import constants from "@/utils/constants";
import router from "@/router";
import store from "@/store";

const switchClientAction = (id) => {
  store.dispatch("overlay/enableOverlay", "Switching clients...");
  store.dispatch("auth/switchClient", { clientId: id }).then(() => {
    store.dispatch("auth/userClientInfo").then(() => {
      router.push({ name: constants.HOME_ROUTE }).catch(() => {});
      store.dispatch("overlay/disableOverlay");
    });
  });
};

export { switchClientAction };
